/**
 * 考试模版列表
 * @author jzhu
 * @date 2020-04-02
 */

import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateConfig} from "./config";
import {framework_tool,component_tool} from '../../../tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport,WizModal} = component_tool;

class ExamTemplate extends WizContainer {
  componentName = 'examTemplate';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCategoryList(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o.success) {
      let f = (vs) => {
        vs && vs.length && vs.forEach(v => {
          v.code = v.id
          v.codeName = v.name
        })
      }
      f(o.data)
      return true
    } else {
      wizNotice.error(o.msg)
      return false
    }
  }

  _handleDelete(nextProps, nextState, key){
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'操作结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("操作失败，请联系相关人员")
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o["success"]) {
      wizNotice.success(o["msg"]);
      return true;
    } else {
      wizNotice.error(o["msg"]);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key){
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: "",
        width: 30,
        field: "rowIndex",
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: "center",
          padding: "5px 0",
          color: "#595959",
          backgroundColor: "#f0f0f0",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "500",
          boxShadow: "0 2px 0px 0 rgba(0,0,0,0.15)",
        },
      },
      {
        headerName: "模版名称",
        field: "title",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "考试分类",
        field: "categoryType",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "状态",
        field: "state",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      /*{
        headerName: "身份验证",
        field: "face",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      }*/,{
        headerName: "考试时长(分钟)",
        field: "limitMinutes",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },{
        headerName: "允许重复考试次数",
        field: "count",
        width: 25,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "总分",
        field: "totalScore",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "通过分数",
        field: "passScore",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },{
        headerName: "成绩规则",
        field: "scoreRule",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "创建人",
        field: "creator",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "创建时间",
        field: "createTime",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      }
    ];
    if (o['success']) {
      let data = o['data']
      data && data.forEach(d => {
        switch (d['state']) {
          case 0: d['state'] = '无效'; break;
          case 1: d['state'] = '有效'; break;
        }
        switch (d['face']) {
          case 0: d['face'] = '已开启'; break;
          case 1: d['face'] = '未开启'; break;
        }
        switch (d['scoreRule']) {
          case 0: d['scoreRule'] = '最高分'; break;
          case 1: d['scoreRule'] = '平均分'; break;
        }
      })
      WizBrowserExport({
        title: '考试模版信息',
        sheetName: '考试模版信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '考试模版信息.xlsx',
      })
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        categoryList: this._handleCategoryList,
        enable: this._handleCMD,
        delete: this._handleDelete,
        export: this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ExamTemplate);
